import React, { useEffect, useRef, useState, useMemo, useContext } from "react";
import { Alert, Box, Button, Checkbox, CircularProgress, Chip, FormControl, FormControlLabel, Grid, LinearProgress, Paper, patch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import CheckIcon from '@mui/icons-material/Check';
import Timer from '../CallBacks/Timer';
import ApiService from "../../functions/apiService";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router';
import ModalBox from '../../components/Modal/ModalBox';
import { Link } from "react-router-dom";
import moment from 'moment/moment';
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";

function LinearProgressWithLabel(props) {
	return (
		<Box sx={{ display: 'flex', alignItems: 'center' }}>
			<Box sx={{ width: '100%', mr: 1 }}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box sx={{ minWidth: 35 }}>
				<Typography variant="body2" color="text.secondary">{`${Math.round(
					props.value,
				)}%`}</Typography>
			</Box>
		</Box>
	);
}

const checkButtonStyle = {
	color: "#FFF",
	minWidth: "0",
	paddingRight: ".02rem",
	background: '#01784F',
	padding: '8px',
	":hover": { color: "#fff", background: "#01784F" },
	":disabled": { color: "#fff", background: '#D0D5DD' }
};

const PositionWork = () => {
	var params = useParams();
	const batch_id = params?.batch_id;
	const jobId = params?.job_id;
	const [loading, setLoading] = useState(false);
	const [reloadData, setReloadData] = useState(false);
	const [submitingPause, setSubmitingPause] = useState(false);
	const [rowSelectionModel, setRowSelectionModel] = useState([]);
	const [viewJobsEmp, setViewJobsEmp] = useState([]);
	const [viewJobsEmpDiscard, setViewJobsEmpDiscard] = useState([]);
	const [ProgressValue, setProgressValue] = useState(0);
	const [empNowSending, setEmpNowSending] = useState(0);
	const [isPaused, setIsPaused] = useState(true);
	const [timerCount, setTimerCount] = useState(5);
	const [patchId, setPatchId] = useState('');
	const [fromPreAccept, setFromPreAccept] = useState(false);
	const [returnbatches, setReturnbatches] = useState([]);
	const [overTime, setOverTime] = useState([]);
	const intervalId = useRef(null);
	const scrollToRef = useRef(null);
	const navigate = useNavigate();
	const [showModal, setShowModal] = useState(false);
	const handleModalClose = () => { setShowModal(false); };
	const [selectedShift, setSelectedShift] = useState(null);
	const pauseId = overTime.map((i) => i.patch_id);
	const [pauseGrenga, setPauseGrenga] = useState('');
	const { pages, pagesName } = useContext(AuthContext);
	const [show, setShow] = useState(false);
	const [requestMessage, setRequestMessage] = useState('');
	const [acceptText, setAcceptText] = useState('')
	const [showAccept, setShowAccept] = useState(false)
	const [showReject, setShowReject] = useState(false)
	const [acceptData, setAcceptData] = useState([])
	const [count, setCount] = useState(0);
	const [isWatchParty, setIsWatchParty] = useState(false);
	const [action, setAction] = useState('');

	const [timer, setTimer] = useState(() => {
		const storedTimer = localStorage.getItem('Timer');
		return storedTimer ? JSON.parse(storedTimer)[0] : 5;
	});
	const timerRef = useRef(timer);

	useEffect(() => {
		timerRef.current = timer;
	}, [timer]);

	const columnsJobs = () => {
		let columns = [
			{
				field: 'Name', headerName: 'Name', flex: 1, minWidth: 300,
			},
			{
				field: 'EMS_Cert', headerName: 'EMT', flex: 1, minWidth: 80,
				valueGetter: (params) => {
					return `${params?.row?.EMT || ''}`;
				}
			},
			{
				field: 'List', headerName: 'List', flex: 1, minWidth: 120,
			},
			{
				field: 'Boxes', headerName: Object.keys(pagesName).includes("TEXT_HOURS_BOXES") && pagesName.TEXT_HOURS_BOXES, flex: 1, minWidth: 110,
			},
			{
				field: 'Offered', headerName: 'Offered', flex: 1, minWidth: 110,
			},
		];
		{
			columns.push(
				{
					field: 'Actions', headerName: 'Actions', flex: 0, minWidth: 450,
					renderCell: (params) => {
						return (
							<>
								{(params?.row?.Status === 'Decline') ? (
									<Button
										variant="contained"
										sx={{
											backgroundColor: 'rgba(230, 39, 25, 0.1)',
											color: 'rgba(230, 39, 25, 1)',
											border: '1px solid rgba(230, 39, 25, 0.4)',
											borderRadius: '30px',
											padding: '4px',
											width: '39%',
											boxShadow: 'none',
											cursor: 'none',
											'&:hover': {
												backgroundColor: 'rgba(230, 39, 25, 0.1)',
												boxShadow: 'none',
											},
										}}
									>
										Rejected
									</Button>
								)
									: (
										<>
											<Button
												variant="contained"
												onClick={() => {
													setShowAccept(true);
													setAcceptData(params.row);
													setAction('accept')
												}}
												sx={{
													backgroundColor: '#01784F',
													color: '#ffffff',
													marginLeft: '10px',
													padding: '8px',
													boxShadow: 'none',
													'&:hover': {
														backgroundColor: '#01784F',
														boxShadow: 'none',
													},
												}}
												disabled={rowSelectionModel.length === 0}
											>
												{acceptText.V3_FILL_SHIFT_ACCEPT_TEXT || 'Accept'}
											</Button>
											<Button
												variant="contained"
												onClick={() => {
													setShowReject(true);
													setAcceptData(params.row);
													setAction('decline')
												}}
												sx={{
													backgroundColor: '#ff0000',
													color: '#ffffff',
													marginLeft: '10px',
													padding: '8px',
													boxShadow: 'none',
													'&:hover': {
														backgroundColor: '#E62719',
														boxShadow: 'none',
													},
												}}
												disabled={rowSelectionModel.length === 0}
											>
												Reject
											</Button>
										</>
									)}

							</>
						)
					}
				}
			)
		}
		return columns
	}

	let columnsJobDiscarded = [
		{
			field: 'Name', headerName: 'Name', flex: 1, minWidth: 200,
		},
		{
			field: 'Reason', headerName: 'Reason', flex: 1, minWidth: 200,
			valueGetter: (params) => {
				return `${params?.row?.discard_reason || ''} ${params?.row?.Reason || ''}`;
			}
		},
	];

	let columnsJobsTob = [
		{
			field: 'Shift_Date',
			headerName: 'Date',
			flex: 1,
			minWidth: 200,
			filterable: false,
			valueGetter: (params) => {
				return moment(params.row.Shift_Date).format('ddd Do, MMMM YYYY');
			}
		},
		{
			field: 'Assignment_Id',
			headerName: 'S_No.',
			flex: 1,
			minWidth: 60,
			filterable: false,
			valueGetter: (params) => (params?.row?.Assignment_Id)
		},
		{
			field: 'Name',
			headerName: 'Name',
			flex: 1,
			minWidth: 180,
			valueGetter: (params) => {
				return (params?.row?.Name?.SO_Desc);
			},
			renderCell: (params) => {
				return (
					<div
						style={{
							whiteSpace: 'normal',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							lineHeight: '1.5',
							wordBreak: 'break-word'
						}}
					>
						{params.value}
					</div>
				);
			}
		},
		{
			field: 'List',
			headerName: 'List',
			flex: 1,
			minWidth: 110,
			renderCell: (params) => {
				return (
					<div
						style={{
							whiteSpace: 'normal',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							lineHeight: '1.5',
							wordBreak: 'break-word'
						}}
					>
						{params?.row?.List}
					</div>
				);
			}
		},
		{
			field: 'filled_employee',
			headerName: 'Action',
			flex: 1,
			minWidth: 160,
			renderCell: (params) => {
				return (
					params?.row?.Status == 'F' ?
						(
							<Chip
								sx={{
									height: 'auto',
									'& .MuiChip-label': {
										display: 'block',
										whiteSpace: 'normal',
									},
								}}
								style={{ textAlign: 'center', padding: '6px 0px', width: '100%', backgroundColor: '#079E46', color: '#ffffff', cursor: 'pointer' }}
								label={params?.row?.employeeName}
							/>
						) : "Not filled"
				);
			}
		},
	];

	const handleBackClick = () => {
		if (!isPaused) {
			clearInterval(intervalId.current);
			setFromPreAccept(false);
			setViewJobsEmp([]);
			setViewJobsEmpDiscard([]);
			navigate("/firehouse/fill-positions");
		} else {
			setShowModal(true);
		}
	};

	const handleBack = () => {
		clearInterval(intervalId.current);
		// setFromPreAccept(false);
		// setViewJobsEmp([]);
		// setViewJobsEmpDiscard([]);
		navigate("/firehouse/fill-positions");
	}

	useEffect(() => {
		if (scrollToRef.current) {
			scrollToRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}, [empNowSending]);


	const getDetails = () => {
		ApiService.post('/fill-position-employee-list', {
			"Batch_Number": batch_id,
			"Timer": timer
		}).then((data) => {
			setViewJobsEmp(data?.offered)
			setViewJobsEmpDiscard(data?.notOffered)
			if (data?.isFilled == true) {
				handleBack();
			}
			setLoading(false);
		}).catch((error) => {
			setLoading(false)
		})
	}

	let VolunteerData = () => {
		setLoading(true);
		ApiService.post('/fill-position-shifts', {
			Batch_Number: batch_id,
		}).then((data) => {
			const updatedRows = data?.data?.map((row) => ({
				...row,
				page: "position-list-fixes",
				id: row.Assignment_Id,
			}));
			if (data?.isFilled == true) {
				handleBack();
			}
			setOverTime(updatedRows);
			setLoading(false);
		}).catch((e) => {
			setLoading(false);
			toast.error(e?.data?.message)
		});
	};

	let TimeData = () => {
		setLoading(true);
		ApiService.get(`/batch/progress/${jobId}`)
			.then((data) => {
				setCount(`${data?.data?.processed} / ${data?.data?.total}`)
				if (empNowSending !== (data?.data?.total - data?.data?.processed)) {
					setTimerCount(5);
				}
				setProgressValue(data?.data?.progress_percentage)
				setLoading(false);
				setEmpNowSending(0);
			}).catch((e) => {
				setLoading(false);
				toast.error(e?.data?.message)
			});
	};

	const acceptReject = () => {
		setLoading(true);
		ApiService.post('/accept-position-employee', {
			Assignment_id: selectedShift?.Assignment_Id,
			Emp_Code: acceptData?.Emp_Code,
			Action: action,
		}).then((data) => {
			setShowAccept(false)
			setShowReject(false)
			toast.success(data?.message)
			setLoading(false);
			setReloadData(true)
			setRowSelectionModel([])
		}).catch((e) => {
			setLoading(false);
			toast.error(e?.data?.error)
		});
	};

	let PauseRestart = async () => {
		setSubmitingPause(true);
		try {
			await ApiService.post('/manage-positions', {
				batch_id: jobId,
				action: isPaused ? 'pause' : 'restart',
				timer: timer
			});
			setIsPaused((pre) => !pre);
		} catch (error) {
			toast.error(error?.data?.message);
		} finally {
			setSubmitingPause(false);
		}
	};


	const handlePauseConfirm = async () => {
		setSubmitingPause(true);
		try {
			await ApiService.post('/manage-positions', {
				batch_id: jobId,
				action: isPaused ? 'pause' : 'restart',
				timer: timer
			});
			navigate("/firehouse/fill-positions");
		} catch (error) {
			setSubmitingPause(false);
			navigate("/firehouse/fill-positions");
		}
	};

	const handleCellClick = (params) => {
		const selectedRow = overTime.find(row => row.id === params.id);
		if (selectedRow?.Status === 'F') {
			return;
		}
		setRowSelectionModel([params.id]);
		setSelectedShift(selectedRow);
	};

	const onRowSelectionModelChange = (newSelection) => {
		const selectedRow = overTime.find(row => row.id === newSelection[0]);
		if (selectedRow?.Status === 'F') {
			setRowSelectionModel([]);
			setSelectedShift(null);
			return;
		}
		setRowSelectionModel(newSelection[0]);
		setSelectedShift(selectedRow);
	};

	useEffect(() => {
		getDetails()
		const timer = setInterval(() => {
			getDetails()
		}, 5000);
		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		setLoading(false);
		VolunteerData();
		const timer = setInterval(() => {
			VolunteerData();
			setLoading(false);
		}, 5000);
		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		setLoading(false);
		TimeData();
		const timer = setInterval(() => {
			TimeData();
			setLoading(false);
		}, 5000);
		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		if (reloadData) {
			VolunteerData();
			setReloadData(false);
			setLoading(false);
		}
	}, [reloadData]);

	useEffect(() => {
		ApiService.get('/v3Variables')
			.then((res) => {
				setAcceptText(res?.data?.data)
			}).catch(({ error }) => {
				console.log('error', error)
			});
	}, [])


	return (
		<>
			<Paper className="p-3" style={{ marginTop: "1rem" }} sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF', position: 'relative' }}>
				<Box className="my-1" sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<Typography variant="h6" style={{ marginBottom: "10px" }}>
						Fill Positions</Typography>
					<Button style={{ color: '#555555' }} onClick={handleBackClick}>
						<img src="/images/back-button.svg" alt="icon" width='30px' height='30px' />
					</Button>
				</Box>

				{loading ? (
					<Box className="w-100 h-100 d-flex justify-content-center align-items-center">
						<CircularProgress />
					</Box>
				) : (
					<>
						<div>
							<Grid container spacing={1}>
								<Grid item xs={8.5}>
									<div className="hide-header-checkbox-page">
										<CollapseComponent
											rows={overTime}
											columns={columnsJobsTob}
											name={`Volunteer Shift`}
											checkboxSelection={true}
											isRowSelectable={(params) => params.row.Status !== 'F'}
											onCellClick={handleCellClick}
											open={true}
											rowSelectionModel={rowSelectionModel}
											onRowSelectionModelChange={onRowSelectionModelChange}
										/>
									</div>
								</Grid>
								<Grid item xs={3.5}>
									<p
										className="w-100 text-dark d-flex justify-content-between  p-2 border-0 my-2"
										style={{ backgroundColor: 'rgb(191, 29, 45)' }}
									>
										<span style={{ fontWeight: "400", color: 'white' }}>Offered</span>
										<div style={{
											marginBottom: "0px",
											marginLeft: '60%',
											borderRadius: '12px',
											backgroundColor: '#ffffff',
											minWidth: '68px',
											height: '24px',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}}>
											<p style={{ fontSize: '12px', fontWeight: '550', margin: 0, color: '#000000' }}>
												{count}
											</p>
										</div>
									</p>
									<div style={{ border: '1px solid #ccc' }}>
										<TableContainer>
											<Table sx={{ maxWidth: "90vw", overflow: "scroll" }} aria-label="simple table">
												<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
													<TableRow>
														<TableCell width="25%">Jobs</TableCell>
														<TableCell width="30%">Timer</TableCell>
														<TableCell width="45%">Action</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
														<TableCell width="25%">
															{count}
														</TableCell>

														<TableCell width="30%">
															{isPaused ?
																<Timer seconds={timerCount} setSeconds={setTimerCount} />
																:
																<div>
																	<input type="text" className="form-control shadow-none"
																		style={{ width: '60px', fontSize: '12px' }}
																		value={timer}
																		onChange={(e) => {
																			const value = e.target.value;
																			if (/^\d*$/.test(value)) {
																				const newTimer = Number(value);
																				setTimer(newTimer);
																				localStorage.setItem('Timer', JSON.stringify([newTimer]));
																			}
																		}}
																	/>
																</div>
															}
														</TableCell>

														<TableCell width="45%">
															{pauseGrenga === 'pause_last_rank' ?
																<>
																	<img src="/images/onduty.svg" width='20px' height='20px' style={{ marginRight: '5px' }} />
																	Rank Pause
																</>
																: ''
															}
															{!isWatchParty &&
																<ButtonTheme color='primary' style={{ marginLeft: '5px' }} onClick={() => { PauseRestart() }}>
																	{isPaused ? submitingPause ? 'Pausing...' : 'Pause' : submitingPause ? 'Restarting...' : 'Restart'}
																</ButtonTheme>
															}
														</TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</TableContainer>
										<LinearProgressWithLabel value={ProgressValue} className='mx-2'></LinearProgressWithLabel>
									</div>
								</Grid>
							</Grid>

							<div>
								{patchId && returnbatches && returnbatches.includes(patchId) && returnbatches?.findIndex((x) => x == patchId) != 0 &&
									<Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
										( {returnbatches?.findIndex((x) => x == patchId)} )  Shift is Done
									</Alert>
								}

								<div>
									<ModalBox
										open={showModal}
										onClose={handleModalClose}
										title="Pause Job"
										body="Do you want to pause the job before leaving?"
										primaryAction={handlePauseConfirm}
										primaryActionText="Yes, Pause & Go Back"
										secondaryActionText="Cancel"
										isPrimaryDisabled={submitingPause}
										secondaryAction={handleModalClose}
										isTertiaryDisabled={submitingPause}
										tertiaryAction={handleBack}
										tertiaryActionText="Only Go Back"
									/>
								</div>
							</div>

							<CollapseComponent
								name={"Offered"}
								// isShowMoreData = {true}
								checkboxSelection={false}
								rows={viewJobsEmp}
								columns={columnsJobs()}
								useTopFilter={false}
								rowCount={viewJobsEmp.length}
								open={true}
							/>

							<CollapseComponent
								name={"Not offered"}
								// isShowMoreData = {true}
								checkboxSelection={false}
								// rows={[...viewJobsEmpDiscard, ...notOfferedEmp]}
								rows={viewJobsEmpDiscard}
								columns={columnsJobDiscarded}
								useTopFilter={false}
								// rowCount={viewJobsEmpDiscard.length + notOfferedEmp.length}
								rowCount={viewJobsEmpDiscard.length}
							/>
						</div>
					</>
				)}
			</Paper>

			<Modal show={show}
				onHide={() => {
					setShow(false);
					setRequestMessage('')
				}}>
				<Modal.Header closeButton>
					<Modal.Title>Request Free Pass</Modal.Title>
				</Modal.Header>
				<Modal.Body className='pb-4'>{requestMessage || ''}</Modal.Body>
			</Modal>

			{/* Accpet Modal */}
			<Modal show={showAccept} onHide={() => setShowAccept(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Accept</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure to Accept ?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setShowAccept(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => acceptReject()}>
								Accept
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			{/* Reject Modal */}
			<Modal show={showReject} onHide={() => setShowReject(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Reject</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure to Reject ?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setShowReject(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => acceptReject()}>
								Reject
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default PositionWork